import { Tag } from 'antd';
import React from 'react';
import { TransferStatusEnum } from '../../../utils/api';
import { transferStatusColor, transferStatusLabel } from '../helpers';

/** Transfer status as a coloured tag; the one way a status is shown anywhere in the app. */
const TransferStatusTag: React.FC<{ status: TransferStatusEnum }> = ({ status }) => (
    <Tag color={transferStatusColor(status)}>{transferStatusLabel(status)}</Tag>
);

export default TransferStatusTag;
